import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { PublicBackground } from '@app/core';
import { Trans } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    marginBottom: theme.marginBase * 4,
  },
}));

interface Props {
  isAbandoned?: boolean;
}

export const ParticipantCancelConfirmation = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <PublicBackground>
      <div>
        <h1 className={classes.title}>
          <Trans
            i18nKey={
              props.isAbandoned
                ? 'booked.confirmAbandon.title'
                : 'booked.confirmCancel.title'
            }
          />
        </h1>
        <p>
          <Trans
            i18nKey={
              props.isAbandoned
                ? 'booked.confirmAbandon.message'
                : 'booked.confirmCancel.message'
            }
          />
        </p>
      </div>
    </PublicBackground>
  );
};
